var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2652_4901)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.6523,
    y: 10.6523,
    width: 27.6957,
    height: 27.6957,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C10.9354 0 0 10.9354 0 24.5C0 38.0646 10.9354 49 24.5 49C38.0646 49 49 38.0646 49 24.5C49 10.9354 38.0646 0 24.5 0ZM35.3756 25.6354L19.0622 35.1963C18.8829 35.3159 18.5841 35.3756 18.4049 35.3756C18.2256 35.3756 17.9268 35.3159 17.7476 35.1963C17.3293 34.8976 17.0902 34.539 17.0902 34.061V14.9988H17.0305C17.0305 14.5207 17.3293 14.0427 17.6878 13.8634C18.0463 13.6841 18.6439 13.5646 19.0622 13.8634L35.3756 23.3646C35.7939 23.6634 36.0329 24.022 36.0329 24.5C36.0329 24.9781 35.7341 25.4561 35.3756 25.6354Z",
    fill: "#203662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2652_4901"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H49V34.3C49 42.4186 42.4186 49 34.3 49H14.7C6.58141 49 0 42.4186 0 34.3V0Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoIcon);
export default __webpack_public_path__ + "static/media/playVideoIcon.3a02fff43275f0a7fda8b469e7450040.svg";
export { ForwardRef as ReactComponent };